<template>
  <div>
    <p class="mb-3">
      In the diagram of the neutral molecule shown below, what unknown element woud E represent?
    </p>

    <p class="mb-0 pl-3">
      <img :src="$publicAsset('/img/assignments/EBr2_LS.png')" width="140px" />
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question337',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking

      inputs: {
        input1: null,
      },
      options: [
        {text: '$\\text{Xe}$', value: 'xe'},
        {text: '$\\text{I}$', value: 'i'},
        {text: '$\\text{Se}$', value: 'se'},
        {text: '$\\text{At}$', value: 'at'},
        {text: '$\\text{Sn}$', value: 'sn'},
      ],
    };
  },
};
</script>
